const intervalId = setInterval(function() {
    const oneTimeRadioLabel = document.querySelector('.onetime-radio');
    if (oneTimeRadioLabel) {
        const benefitWidget = document.createElement('ul');
        benefitWidget.classList.add('rc_benefit_widget');
        benefitWidget.innerHTML = `
            <li><b>FREE SHIPPING</b> every month</li>
            <li><b>NO CONTRACT</b> cancel easily</li>
            <li><b>10% OFF</b> future orders</li>
            <li><b>OUT OF STOCK PROTECTION</b></li>
        `;
        oneTimeRadioLabel.parentNode.insertBefore(benefitWidget, oneTimeRadioLabel);
        clearInterval(intervalId);
    }
}, 100);  



// // Select the span element
// const saveSpan = document.querySelector('.savePercen.jeet');

// // Check if the element exists
// if (saveSpan) {
//     // Update the text content
//     saveSpan.textContent = 'BEST DEAL';
// }







